import { render, staticRenderFns } from "./SorryMessage.vue?vue&type=template&id=20b21ebd&scoped=true&"
import script from "./SorryMessage.vue?vue&type=script&lang=js&"
export * from "./SorryMessage.vue?vue&type=script&lang=js&"
import style0 from "./SorryMessage.vue?vue&type=style&index=0&id=20b21ebd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b21ebd",
  null
  
)

export default component.exports